import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteCareerCounselingStudent,
  getAllPostStudents,
} from "../../services/postService.services";
import toast from "react-hot-toast";

// Async thunk to fetch students
export const fetchStudents = createAsyncThunk(
  "students/fetchStudents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllPostStudents();

      return response;
    } catch (error) {
      return rejectWithValue("Failed to load student data.");
    }
  }
);

// Async thunk to delete a student
export const deleteStudent = createAsyncThunk(
  "students/deleteStudent",
  async (studentId, { dispatch, rejectWithValue }) => {
    try {
      await deleteCareerCounselingStudent(studentId);
      toast.success("Student deleted successfully");
      dispatch(fetchStudents()); // Refresh list after deletion
    } catch (error) {
      return rejectWithValue("Failed to delete student.");
    }
  }
);

const postServiceStudentSlice = createSlice({
  name: "postServiceStudents",
  initialState: {
    students: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.students = action.payload;
      })
      .addCase(fetchStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteStudent.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default postServiceStudentSlice.reducer;
